<script lang="ts">
  import { yyyy, goto } from "../store.svelte";

  const chooser = (choice: string) => {
    yyyy.createNewLiveWire.choice = choice;
    if (choice === "new") {
      yyyy.createNewLiveWire.name = true;
    }
  };

  const cancel = () => {
    goto("/livewires");
  };
</script>

<div class="choice-container">
  <div class="choice-card">
    <header class="choice-header">
      <h1 class="title">Create New Livewire</h1>
      <p class="subtitle">Choose your data source</p>
    </header>

    <div class="choice-body">
      <div class="choices">
        <button
          type="button"
          class="choice-option"
          onclick={() => chooser("new")}
        >
          <span class="choice-title">New Data</span>
          <span class="choice-desc">
            Upload new data and configure the livewire from scratch.
            Grab some caffeine, it may take a while.
          </span>
        </button>

        <button
          type="button"
          class="choice-option"
          onclick={() => chooser("old")}
        >
          <span class="choice-title">Existing Livewire</span>
          <span class="choice-desc">
            Update an existing livewire with new data.
            The data must have the same structure.
          </span>
        </button>
      </div>
    </div>

    <footer class="choice-footer">
      <button class="button is-danger is-outlined" onclick={cancel}>
        Cancel
      </button>
    </footer>
  </div>
</div>

<style>
  .choice-container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 70%;
    max-width: 900px;
    height: fit-content;
    max-height: 90vh;
    padding: 1rem;
    z-index: 5;
  }

  .choice-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .choice-header {
    background: linear-gradient(135deg, #ff3e00 0%, #ff6b35 100%);
    color: white;
    padding: 1.5rem 2rem;
  }

  .choice-header .title {
    color: white;
    font-size: 1.5rem;
    font-weight: 300;
    text-transform: uppercase;
    margin-bottom: 0.25rem;
  }

  .choice-header .subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.9rem;
  }

  .choice-body {
    padding: 2rem;
    min-height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .choices {
    display: flex;
    gap: 2rem;
    width: 100%;
    max-width: 800px;
  }

  .choice-option {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 2rem;
    background: #f9f9f9;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .choice-option:hover {
    background: #fff3e0;
    border-color: #ff3e00;
  }

  .choice-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.75rem;
  }

  .choice-option:hover .choice-title {
    color: #ff3e00;
  }

  .choice-desc {
    font-size: 0.9rem;
    color: #666;
    line-height: 1.5;
  }

  .choice-footer {
    display: flex;
    justify-content: flex-start;
    padding: 1rem 2rem;
    border-top: 1px solid #e0e0e0;
    background: #fafafa;
  }
</style>
